module.exports = __webpack_public_path__ + "img/footer_logo.11d16987.png";